import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["initialState"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { HYDRATE } from 'next-redux-wrapper';
import React, { useEffect, useMemo } from 'react';
import { JssProvider, ThemeProvider } from 'react-jss';
import { Provider } from 'react-redux';
import LogRocket from 'logrocket';
import Script from 'next/script';
import AppGate from '../containers/AppGate';
import I18nProvider from '../i18n/Provider';
import { wrapper, makeStore } from '../redux';
import getPageContext from '../theme/context';
import AppSagas from '../redux/app/sagas';
import bugsnagClient from '../helpers/BugsnagHelpers';
import { app } from '../configuration';
var MyApp = function MyApp(props) {
  // eslint-disable-next-line react/prop-types
  var initialState = props.initialState,
    pageProps = _objectWithoutProperties(props, _excluded);

  // We provide the store manually instead of wrapper.useWrappedStore() because
  // the latter calls useRouter() which throws "NextRouter was not mounted"
  // during SSR with this Next custom server. makeStore() returns the client
  // singleton (or a fresh server store) and we hydrate it from the serialized
  // state produced by getInitialAppProps.
  var store = useMemo(function () {
    return makeStore();
  }, []);
  useMemo(function () {
    if (initialState) {
      store.dispatch({
        type: HYDRATE,
        payload: initialState
      });
    }
  }, [store, initialState]);
  if (typeof window === "undefined") {
    var originalWarn = console.warn;
    console.warn = function () {
      if ((arguments.length <= 0 ? undefined : arguments[0]) !== 'Warning: [JSS] Rule is not linked. Missing sheet option "link: true".') {
        originalWarn.apply(void 0, arguments);
      }
    };
  }
  var pageContext = useMemo(getPageContext, []);

  /* useEffect(() => {
     const jssStyles = document.querySelector('#jss-server-side')
      if (jssStyles && jssStyles.parentNode) {
       jssStyles.parentNode.removeChild(jssStyles)
     }
      if (!app.USE_PWA) {
       try {
         // eslint-disable-next-line no-unused-expressions
         navigator?.serviceWorker?.getRegistrations().then((registrations) => {
           // eslint-disable-next-line no-restricted-syntax
           for (const registration of registrations) {
             registration.unregister()
           }
         })
       } catch (e) {
         console.log('service worker unregister error', e)
       }
     }
   }, [])*/

  useEffect(function () {
    LogRocket.init('oht1mo/balenciaga-cv');
  }, []);
  var gtmScript = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\nnew Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\nj=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n})(window,document,'script','dataLayer','".concat(app.GTM_ID, "');");
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Script, {
    id: "gtm-bootstrap",
    strategy: "afterInteractive",
    dangerouslySetInnerHTML: {
      __html: gtmScript
    }
  }), /*#__PURE__*/React.createElement(JssProvider, {
    registry: pageContext.sheetsRegistry,
    jss: pageContext.jss,
    generateId: pageContext.generateId
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: pageContext.theme
  }, /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(I18nProvider, {
    store: store
  }, /*#__PURE__*/React.createElement(AppGate, _extends({
    pageContext: pageContext
  }, pageProps)))))));
};
MyApp.getInitialProps = wrapper.getInitialAppProps(function (store) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var Component, ctx, props, _t;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            Component = _ref.Component, ctx = _ref.ctx;
            _context.prev = 1;
            _context.next = 2;
            return ctx.store.saga.run(AppSagas.init, ctx, Component == null ? void 0 : Component.getInitialProps).toPromise();
          case 2:
            props = _context.sent;
            return _context.abrupt("return", props || {});
          case 3:
            _context.prev = 3;
            _t = _context["catch"](1);
            if (bugsnagClient) {
              bugsnagClient.notify(_t);
            }
            console.error(_t);
            return _context.abrupt("return", {});
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }();
});
export default MyApp;